export default __webpack_public_path__ + "static/media/Jost-Regular.ba7997a1.ttf";